import React, { Component } from "react";
import { Typography, Button, Input } from "antd";

import PhoneVerificationIcon from "icons/PhoneVerificationIcon";
import OkModal from "components/modal/OkModal";
import { requestResetPassword } from "api/api";
import { displayGenericError } from "common/notifications";
import { validateEmail } from 'utils/utils'
import "./ForgotPasswordPage.scss";

const { Text } = Typography;

export default class ForgotPasswordPage extends Component {
  state = {
    email: "",
    message: "",
    visible: false,
    errorMessage: ""
  };
  componentDidMount(){
    this.mailInput.focus();
  }
  resetPassword = () => {
    if (!validateEmail(this.state.email)) {
      displayGenericError({ message: "You typed an incorrect email address" })
      return;
    }

    requestResetPassword(this.state.email)
      .then(() => {
        this.setState({ visible: true, message: "Please check your email" });
      })
      .catch(e => displayGenericError(e));
  };

  render() {
    return (
      <div className="forgot-password-wrapper">
        <div className="inner-content">
          <PhoneVerificationIcon />
          <h2 className="fw-700">Forgot Password</h2>
          <p className="describe">
            Enter email address associated with your account. We will send you a
            link to reset your password
          </p>

          <Input
            type="text"
            size="large"
            className="line-bottom-input"
            ref={(input) => { this.mailInput = input; }}
            onChange={e => this.setState({ email: e.target.value })}
            value={this.state.email}
          />
          <div className="buttons-section">
            <Button
              type="primary"
              className="btn-wide-md"
              onClick={this.resetPassword}
            >
              Reset Password
            </Button>
          </div>
          {this.state.errorMessage && (
            <Text style={{ color: "red" }}>{this.state.errorMessage}</Text>
          )}
          <OkModal
            message={this.state.message}
            visible={this.state.visible}
            handleOk={() => this.props.history.push("/login?hide-signup-modal=true")}
            title="Reset Password"
          />
        </div>
      </div>
    );
  }
}
